import * as React from "react";
import { Icon } from "@chakra-ui/react";
const Internal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#F89921", d: "M2 2h2.736L9.94 12.46 15.107 2h2.686L9.911 18z" }), /* @__PURE__ */ React.createElement("path", { fill: "#898B8D", d: "m6.34 2.03 3.562 7.1 3.552-7.1z" }));
const SvgVeevaLightmode = (props) => {
  return /* @__PURE__ */ React.createElement(Icon, { as: Internal, ...props });
};
export default SvgVeevaLightmode;
